<template>
  <div class="active_page">
    <div class="content">
      <div class="header">
        <img src="../../assets/718_header.png" @click="toNative('creditlist', '活动页大图跳转')">
      </div>
      <div class="timing outbox">
        <img src="../../assets/718_activetime.png">
        <div class="container">
          <h3>领取时间</h3>
          <div class="top text">
            <p>2018年07月18日00:00:00</p>
            <p>至2018年07月24日23:59:59</p>
          </div>
          <h3>使用时间</h3>
          <div class="text">
            <p>2019年08月31日23:59:59之前</p>
          </div>
        </div>
      </div>
      <div class="join outbox">
        <img src="../../assets/718_joinway.png">
        <div class="container">
          <div class="text">通过718活动链接注册后即可领取，下载“钱站官方版”APP在【我的】中可查看已领取的红包，注册后7天内成功借款的客户在还款时可使用此次发放的还款红包。</div>
        </div>
      </div>
      <div class="rules outbox">
        <img src="../../assets/718_usingrule.png">
        <div class="container">
          <ul>
            <li>
              <div class="dot"></div>
              <div class="text">成功借款即可使用共计100元的6个还款红包。</div>
            </li>
            <li>
              <div class="dot"></div>
              <div class="text">借款金额达到1万元以上，可以使用共计388元的12个还款红包(包括1万及以下的100元红包)。</div>
            </li>
            <li>
              <div class="dot"></div>
              <div class="text">借款金额达到3万元以上，可以使用所有共计888元的18个还款红包。</div>
            </li>
            <li>
              <div class="dot"></div>
              <div class="text">每月还款时仅可使用一个还款红包，不可叠加使用。</div>
            </li>
            <li>
              <div class="dot"></div>
              <div class="text">使用红包金额大小不可超过当期服务费金额。如当期服务费为20元，则仅可使用小于等于20元红包。</div>
            </li>
            <li>
              <div class="dot"></div>
              <div class="text">红包只可在偿还当期时进行抵扣，不可转让、不可兑现、不可代付，本次活动奖励不得与其他活动叠加。</div>
            </li>
            <li>
              <div class="dot"></div>
              <div class="text">此次红包不适用于提前结清、还款表现异常(逾期)的情况。</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="tips">
        <p>本次活动规则最终解释权归钱站所有</p>
        <p>如有任何问题请联系在线客服</p>
      </div>
    </div>
    
    <div class="buttons">
      <a href="javascript:;" @click="toNative('mycoupon', '活动页查看红包按钮')" class="hongbao item">
        查看红包
      </a>
      <a href="javascript:;" @click="toNative('creditlist', '活动页立即申请按钮')" class="apply item">
        立即申请
      </a>
    </div>
  </div>
</template>

<style lang="less" rel="stylesheet/less" scoped="">
  .active_page {
    width: 100%;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    background: #db0023;
    text-align: center;
    .content {
      overflow: scroll;
      height: 100%;
      .header {
        margin-bottom: 24px;
        img {
          width: 100%;
        }
      }
      .outbox {
        margin: 0 auto;
        margin-bottom: 24px;
        img {
          width: 120px;
          margin-bottom: 13px;
        }
        .container {
          width: 318px;
          background: #fff;
          border-radius: 7px;
          margin: 0 auto;
          padding: 32px 24px;
          color: #373f5f;
          font-size: 14px;
          h3 {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .text {
            line-height: 20px;
          }
          .top {
            margin-bottom: 20px;
          }
          ul {
            li {
              overflow: hidden;
              margin-bottom: 20px;
              &:last-child {
                margin-bottom: 0;
              }
              .dot {
                float: left;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-image: linear-gradient(-153deg, #fdea73 5%, #ffad00 100%);
                margin-top: 6px;
              }
              .text {
                float: left;
                width: 250px;
                margin-left: 11px;
                text-align: left;
              }
            }
          }
        }
      }
      .tips {
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        margin-top: 25px;
        margin-bottom: 100px;
      }
    }

    .buttons {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 72px;
      background: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      &:before, &:after {
        content: "";
        display: block;
      }
      .item {
        display: flex;
        width: 160px;
        height: 48px;
        border-radius: 4px;
        font-size: 18px;
        align-items: center;
        justify-content: center;
      }
      .hongbao {
        border: 1px solid #ff001f;
        color: #ff5300;
      }
      .apply {
        background: #ff5300;
        box-shadow: 0 2px 30px 0 rgba(251,91,33,0.50);
        color: #fff;
      }
    }
  }
</style>
<script  >
  export default{
    props: {},
    methods: {
      toNative(dest, log) {
        const processFlag = window.sessionStorage.getItem('h5Process');
        this.$reportLog(processFlag === 1 ?'h5_lc' : 'qianzhan', 'btn', log);
        this.$router.push({ name: dest });
      }
    }
  };
</script>